import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PartnerService } from 'src/app/services/partner.service';
import { ChecklistService } from 'src/app/services/checklist.service';
import { ServiceRequestService } from 'src/app/services/servicerequest.service';
import { ServiceTypeService } from 'src/app/services/service-type.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { JobcardService } from 'src/app/services/jobcard.service';
import { WorkshopJobcardCreateService } from './workshop-jobcard-create.service';
import { WorkshopJobcardAccordionComponent } from './workshop-jobcard-accordion/workshop-jobcard-accordion.component';
import { WorkshopJobcardLinkServicesComponent } from './workshop-jobcard-linked-services/workshop-jobcard-link-services/workshop-jobcard-link-services.component';
import moment from 'moment';
import { forkJoin, from } from 'rxjs';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { WorkshopJobcardGroupJobsModalComponent } from './workshop-jobcard-group-jobs-modal/workshop-jobcard-group-jobs-modal.component';
import { WorkshopJobcardContext } from './workshop-jobcard.context';
import { ThirdPartyService } from 'src/app/services/thirdparty.service';

@Component({
  selector: 'app-workshop-jobcard',
  templateUrl: './workshop-jobcard.component.html',
  styleUrls: ['./workshop-jobcard.component.scss']
})
export class WorkshopJobcardComponent implements AfterViewInit, OnChanges, OnDestroy {

  @Input() selectedTimeSlot;
  @Input() technician;
  @Input() fromCalendar;
  @Input() jobCardID: number = null;
  @Input() goToMessaging: boolean = false;
  @Input() selectedItem: any = null;
  @Input() customer: any = null;
  @Input() isPhoneView: boolean = false;
  @Input() rentalBooking: boolean = false;

  // Get the ElementRef directly, not the component
  @ViewChild('header', { read: ElementRef, static: false }) headerElement: ElementRef;
  @ViewChild('workshopJobCardContainer', { read: ElementRef, static: false }) containerElement: ElementRef;
  @ViewChild('linkedItemsContainer', { read: ElementRef, static: false }) linkedItemsContainer: ElementRef;
  @ViewChild('linkedServicesItems', { static: false }) linkedServicesItemsRef!: ElementRef;
  @ViewChild('linkAnotherJobButton', { static: false }) linkAnotherJobButtonRef!: ElementRef;
  @ViewChild('workshopJobcardAccordion', { static: false }) workshopJobcardAccordionComponent: WorkshopJobcardAccordionComponent;

  public jobcard: any = {};
  public systemUsers: any[] = [];
  public technicians: any[] = [];
  public thirdParties: any[] = [];
  public preServiceChecklist: any[] = [];
  public originalPreServiceChecklist: any[] = [];
  public serviceTypes: any = [];
  public originalJobcard: any = {};
  public draftJobcard: any = {};
  public productSKUServiceTypeCollection: any = [];
  public busySchedulingService: boolean = false;
  public jobCards: any[] = [];
  public sendCommunication: boolean = true;
  public groupBookings: boolean = false;
  public collectionsConfigured: boolean = false;
  public loadingJobcard: boolean = false;
  public linkedServices: any[] = [];
  public linkableServices: any[] = [];
  public linkedJobsOwner: number | null = null;
  public showLinkedServices: boolean = false;
  public linkedTags: any[] = [];
  public isLocked: boolean = false;

  // Overflow functionality for linked services
  public visibleLinkedServices: any[] = [];
  public overflowLinkedServices: any[] = [];
  public showLinkedOverflow: boolean = false;
  public showLinkAnotherJobButton: boolean = true;
  public linkAnotherJobButtonWidth: number = 0;

  private resizeTimeout: any;
  private resizeHandler = () => {
    // Debounce resize events to avoid excessive calculations
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.checkScreenWidth();
      this.calculateVisibleLinkedServices();
    }, 100);
  };

  constructor(
    public activeModal: NgbActiveModal,
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private checklistService: ChecklistService,
    private serviceRequest: ServiceRequestService,
    private serviceTypeService: ServiceTypeService,
    public workshopJobcardCreateService: WorkshopJobcardCreateService,
    private messageService: MessageService,
    private translate: TranslateService,
    private jobcardService: JobcardService,
    private modalService: NgbModal,
    private ctx: WorkshopJobcardContext,
    private thirdPartyService: ThirdPartyService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    // Check initial screen width
    this.checkScreenWidth();
    console.log(this.selectedItem, this.customer);
    if (!this.jobCardID || this.jobCardID <= 0) {
      this.initializeNewJobCard();
    } else {
      this.jobcard = { id: this.jobCardID };
      this.fetchJobCardDetails(this.jobCardID);
    }

  }

  ngAfterViewInit() {
    // Add resize event listener for overflow calculation and screen width detection
    window.addEventListener('resize', this.resizeHandler);

    // Check screen width after view initialization
    this.checkScreenWidth();

    // setTimeout(() => {
    //   this.adjustContainerPadding();
    // }, 100);
  }

  ngOnDestroy() {
    // Clean up resize event listener
    window.removeEventListener('resize', this.resizeHandler);
  }

  /**
   * Check screen width and update isPhoneView accordingly
   */
  private checkScreenWidth(): void {
    if (typeof window !== 'undefined') {
      const screenWidth = window.innerWidth;
      this.isPhoneView = screenWidth < 800;
    }
  }

  calculateVisibleLinkedServices() {
    // If no linked services, reset everything
    if (!this.linkedServices || this.linkedServices.length === 0) {
      this.visibleLinkedServices = [];
      this.overflowLinkedServices = [];
      return;
    }
    // Initially show all items as a fallback
    this.visibleLinkedServices = [...this.linkedServices];
    this.overflowLinkedServices = [];

    // Ensure DOM is updated first
    this.cdr.detectChanges();

    // Use setTimeout to ensure DOM elements are rendered
    setTimeout(() => {
      if (!this.linkedItemsContainer?.nativeElement || !this.linkedServicesItemsRef?.nativeElement) {
        return; // Keep showing all items
      }

      const containerWidth = this.linkedItemsContainer.nativeElement?.offsetWidth || 0;
      const buttons: HTMLElement[] = Array.from(this.linkedServicesItemsRef?.nativeElement.querySelectorAll('hub-button'));
      const items: HTMLElement[] = Array.from(this.linkedServicesItemsRef.nativeElement.querySelectorAll('.linked-service-item'));

      let usedWidth = 0;
      let visibleCount = 0;
      usedWidth = buttons.reduce((total, btn) => total + (btn.offsetWidth || 0) + 8, 0); // 8px gap

      // Calculate how many items fit
      for (let i = 0; i < this.linkedServices.length; i++) {
        const itemWidth = items[i] ? items[i].offsetWidth + 8 : 150; // 8px gap + estimated width
        const overflowButtonWidth = this.linkedServices.length > visibleCount + 1 ? 80 : 0; // Estimated overflow button width


        if (usedWidth + itemWidth + this.linkAnotherJobButtonWidth + overflowButtonWidth + 16 <= containerWidth) {
          usedWidth += itemWidth;
          visibleCount++;
        } else {
          break;
        }
      }

      // Ensure at least one item is visible if there are any, unless we have space issues
      if (visibleCount === 0 && this.linkedServices.length > 0 && containerWidth > 200) {
        visibleCount = 1;
      }

      // Only apply overflow if we actually need it
      if (visibleCount < this.linkedServices.length && visibleCount > 0) {
        this.visibleLinkedServices = this.linkedServices.slice(0, visibleCount);
        this.overflowLinkedServices = this.linkedServices.slice(visibleCount);
      } else {
        // Show all items if we have space or calculation failed
        this.visibleLinkedServices = [...this.linkedServices];
        this.overflowLinkedServices = [];
      }

      // Trigger change detection after updating the properties
      this.cdr.detectChanges();
    }, 0); // Slightly longer delay to ensure DOM is stable
  }


  initializeNewJobCard() {
    console.log(this.selectedItem);
    this.jobcard = {
      fromCalendar: this.fromCalendar,
      createdBy: this.helpersService.getProfileData().ID,
      scheduleDate: this.selectedTimeSlot ? moment.utc(this.selectedTimeSlot).format('YYYY-MM-DDTHH:mm') : null,
      bookedDate: this.selectedTimeSlot ? new Date(moment.utc(this.selectedTimeSlot).format('YYYY-MM-DDTHH:mm')) : null,
      technician: this.technician && this.technician.id ? parseInt(this.technician.id) : null,
      selectedServiceTypes: [],
      itemIsHere: this.helpersService.getPartnerData().BikeIsHereDefault
    };

    //Just set some default data for times where they booked from the calendar
    if (this.fromCalendar && this.technician && this.technician.id && this.selectedTimeSlot) {
      this.jobcard.originalTechnician = parseInt(this.technician.id);
      this.jobcard.originalScheduleDate = moment.utc(this.selectedTimeSlot).format('YYYY-MM-DDTHH:mm');
    }

    //This is for rental bookings where we pass in the selected item and customer for the rental item being serviced
    if (this.customer && this.customer.ID) {
      this.jobcard.customer = {
        ID: this.customer.ID,
        Name: this.customer.Name,
        Surname: this.customer.Surname,
        Email: this.customer.Email,
        PhoneNumber: this.customer.PhoneNumber,
        Locked: true
      }
      if (this.selectedItem && this.selectedItem.bikeID) {
        this.jobcard.selectedItem = {
          id: this.selectedItem.bikeID,
          manufacturer: this.selectedItem.brand,
          model: this.selectedItem.model,
          serialNo: this.selectedItem.serialNumber,
          colour: this.selectedItem.color,
          modelYear: this.selectedItem.yearModel,
          bikeSize: this.selectedItem.size,
          locked: true
        }
        this.sendCommunication = false;
      }
    }
    if (this.selectedItem)
      if (this.selectedItem.searchedBySerial) {
        this.jobcard.customer.Locked = false;
        this.jobcard.selectedItem.locked = false;
      }

    this.originalJobcard = JSON.parse(JSON.stringify(this.jobcard));
    this.draftJobcard = JSON.parse(JSON.stringify(this.jobcard));
    this.getPreServiceChecklist();
    this.getServiceTypesWithSKUs();
    this.getProductSKUServiceTypeCollection();
    this.getSystemUsers();
    this.getThirdParties();

    this.collectionsConfigured = this.helpersService.getPartnerData().OffersCollections;
  }

  fetchJobCardDetails(jobCardID: number = null) {
    if (jobCardID) {
      this.loadingJobcard = true;
      this.serviceRequest.getManageJobCardDetails(jobCardID).subscribe((jobcard) => {
        this.jobcard = { ...jobcard };
        if (this.jobcard.quote == null) {
          //Handle cases where quote is null (might be failed jobcard bookings)
          this.jobcard.quote = {};
        }
        if (this.jobcard.quote?.couponResponse && this.jobcard.quote?.couponResponse.coupon) {
          this.jobcard.quote.couponDiscountType = this.jobcard.quote?.couponResponse.coupon.type;
          this.jobcard.quote.couponDiscount = this.jobcard.quote.couponResponse.coupon.percentValue || this.jobcard.quote.couponResponse.coupon.fixedValue;
        }
        //this.jobCards = [this.jobcard];
        this.getServiceTypesWithSKUs();
        this.getProductSKUServiceTypeCollection();
        this.getSystemUsers();
        this.getThirdParties();
        this.refreshLockState();
        this.loadingJobcard = false;
      });
      this.getLinkedjobCards();
    }
  }

  getLinkedjobCards() {
    this.serviceRequest.getLinkedJobCards(this.helpersService.getPartnerId(), this.jobCardID).subscribe((linkedJobCards) => {
      console.log('Received linkedJobCards data:', linkedJobCards);
      this.linkedServices = linkedJobCards.linkedServices;
      this.linkableServices = linkedJobCards.linkableServices;
      this.linkedJobsOwner = (this.linkedServices || []).map(s => s.linkedJobsOwner ?? s.LinkedJobsOwner).find(id => id) || null;

      // Immediately show all items to ensure something renders
      this.visibleLinkedServices = [...this.linkedServices];
      this.overflowLinkedServices = [];

      // Force change detection
      this.cdr.detectChanges();

      // Calculate visible linked services after data is loaded
      setTimeout(() => {
        this.calculateVisibleLinkedServices();
      }, 0);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('Main - Changes detected:', changes);
  }

  // private adjustContainerPadding(): void {

  //   if (this.headerElement && this.containerElement) {
  //     // Get the actual rendered height including all content
  //     const headerHeight = this.headerElement.nativeElement.scrollHeight || this.headerElement.nativeElement.offsetHeight || this.headerElement.nativeElement.firstChild?.clientHeight;
  //     console.log('Header height:', headerHeight);

  //     if (headerHeight > 0) {
  //       // Set padding-top based on header height
  //       this.containerElement.nativeElement.style.paddingTop = `${headerHeight}px`;
  //       console.log('Set padding-top to:', `${headerHeight}px`);
  //       document.documentElement.style.setProperty('--header-height', `${headerHeight + (this.jobCards.length > 0 ? 46 : 0)}px`);
  //     } else {
  //       this.containerElement.nativeElement.style.paddingTop = `${112}px`; //Manually set it for now
  //       document.documentElement.style.setProperty('--header-height', `${112 + (this.jobCards.length > 0 ? 46 : 0)}px`);
  //       console.warn('Header height is 0, retrying...');
  //       setTimeout(() => {
  //         this.adjustContainerPadding();
  //       }, 200);
  //     }
  //   } else {
  //     console.warn('Elements not found:', {
  //       header: !!this.headerElement,
  //       container: !!this.containerElement
  //     });
  //   }
  // }

  // The primary customer's last remaining (not cancelled) job card in a group can't be cancelled
  get isPrimaryCustomersLastJobCard(): boolean {
    const services = this.linkedServices || [];
    const owner = Number(this.linkedJobsOwner);
    if (!owner || services.length < 2) return false;
    const currentID = Number(this.jobcard?.id ?? this.jobCardID);
    const current = services.find(s => Number(s.id) === currentID);
    if (!current || Number(current.customerID) !== owner) return false;
    return services.filter(s => Number(s.customerID) === owner && Number(s.statusID) !== 100).length <= 1;
  }

  onFavouriteCustomerChanged(customerID: number | null) {
    this.linkedJobsOwner = customerID;
  }

  onJobCardChange(event: any): void {
    this.jobcard = event;
    this.refreshLockState();
  }

  formReset(event: any) {
    this.jobcard = event.jobcard;
    this.preServiceChecklist = event.preServiceChecklist;
    this.refreshLockState();
  }

  refreshLockState() {
    this.isLocked = this.helpersService.isJobcardLocked(this.jobcard);
  }

  close() {
    this.activeModal.close();
  }

  dismiss() {
    this.activeModal.dismiss();
  }


  getPreServiceChecklist() {
    this.checklistService
      .getPreServiceChecklist(this.helpersService.getPartnerId())
      .subscribe((checklist) => {
        this.preServiceChecklist = checklist;
        this.originalPreServiceChecklist = JSON.parse(JSON.stringify(checklist));
      });
  }

  getServiceTypesWithSKUs() {
    this.serviceTypeService.getPartnerServiceTypeWithLinkedSKUs(this.helpersService.getPartnerId()).subscribe((serviceTypes) => {
      this.serviceTypes = serviceTypes;
      this.ctx.setServiceTypes(this.serviceTypes);
    });
  }

  getProductSKUServiceTypeCollection() {
    this.serviceTypeService.getPartnerProductSKUsWithLinkedServices(this.helpersService.getPartnerId()).subscribe((result) => {
      this.productSKUServiceTypeCollection = result;
      this.workshopJobcardCreateService.convertToUpperCase(this.productSKUServiceTypeCollection);
    });
  }

  getJSONString(object): string {
    return JSON.stringify(object, null, 2);
  }

  scheduleService(createAnother: boolean = false, openBooking: boolean = false) {
    this.busySchedulingService = true;
    var serviceRequestData = {
      "PartnerID": this.helpersService.getPartnerId(),
      "ItemID": this.jobcard.selectedItem.id,
      "ServiceTypes": this.jobcard.selectedServiceTypes.map(item => item.serviceTypeID),
      "ServiceDate": this.jobcard.scheduleDate ? moment(this.jobcard.scheduleDate).format("YYYY-MM-DDTHH:mm:ss") : null,
      "RequiredByDate": this.jobcard.requiredByDate ? moment(this.jobcard.requiredByDate).format("YYYY-MM-DDTHH:mm:ss") : null,
      "PleaseBookIn": true,
      "Notes": this.jobcard.clientNotes || '',
      "TechnicianID": this.jobcard.technician || null,
      "isBikeHere": this.jobcard.collectionsDeliveries && this.jobcard.collectionsDeliveries?.allowCollection ? false : this.jobcard.itemIsHere || false,
      "CouponCode": this.jobcard?.quote?.couponCode || '',
      "BikeBay": this.jobcard.bayNo || null,
      "PreServiceChecklist": this.preServiceChecklist && this.preServiceChecklist.length > 0 ? this.preServiceChecklist.map(item => {
        return {
          ID: item.id,
          ControlType: item.controlType || '',
          DefaultValue: item.defaultValue || null,
          FrontValue: item.frontValue || null,
          RearValue: item.rearValue || null,
        }
      }).filter(item => { return item.DefaultValue || item.FrontValue || item.RearValue; }) : 0,
      "IsCollection": this.jobcard.collectionsDeliveries &&
        this.jobcard.collectionsDeliveries.allowCollection &&
        this.jobcard.collectionsDeliveries.collectionInfo &&
        this.jobcard.collectionsDeliveries.collectionInfo.fullAddress?.address &&
        this.jobcard.collectionsDeliveries.collectionInfo.scheduleDate ? true : false,
      "IsDelivery": this.jobcard.collectionsDeliveries && this.jobcard.collectionsDeliveries.allowDelivery,
      "CollectionInfo": this.jobcard.collectionsDeliveries &&
        this.jobcard.collectionsDeliveries.allowCollection &&
        this.jobcard.collectionsDeliveries.collectionInfo &&
        this.jobcard.collectionsDeliveries.collectionInfo.fullAddress?.address &&
        this.jobcard.collectionsDeliveries.collectionInfo.scheduleDate ? {
        "ScheduleDate": moment(this.jobcard.collectionsDeliveries.collectionInfo.scheduleDate).format("YYYY-MM-DDTHH:mm:ss"),
        "FullAddress": this.jobcard.collectionsDeliveries.collectionInfo.fullAddress.address,
        "Notes": this.jobcard.collectionsDeliveries.collectionInfo.notes || '',
        "AddressDetails": this.jobcard.collectionsDeliveries.collectionInfo.addressDetails,
        "TimeSlot": this.jobcard.collectionsDeliveries.collectionInfo.timeSlot,
        "CollectionFee": this.jobcard.collectionsDeliveries.collectionInfo.collectionFee,
      } : null,
      "CreatedBy": this.jobcard.createdBy,
      //"ConsentForMarketing": true,
      "SelectedThirdParty": this.jobcard.thirdPartyID ? this.jobcard.thirdPartyID : null,
      "SelectedThirdPartyIsResponsibileForPayment": this.jobcard.thirdPartyID && this.jobcard.thirdPartyIsResponsibleForPayment ? true : false,
      LineItems: this.jobcard.quote?.lineItems?.map(lineItem => {
        return {
          InternalProductID: lineItem.InternalProductID,
          Quantity: lineItem.Quantity || 1,
          UnitPrice: lineItem.UnitPrice || 0,
          Tax: lineItem.Tax || 0,
          UnitPrice_IncludingTax: lineItem.UnitPrice_IncludingTax || 0,
          Discount: lineItem.Discount || 0,
          DiscountID: lineItem.DiscountID || null,
          LineItemNote: lineItem.LineItemNote || ''
        };
      }),
      ServiceTypeQuestions: this.jobcard.customQuestions && this.jobcard.customQuestions.length > 0 ? this.jobcard.customQuestions : []
    }

    this.partnerService.scheduleWorkshopService(serviceRequestData, this.sendCommunication).subscribe((response) => {
      this.busySchedulingService = false;
      if (response && response.ID) {
        var createdJobCard = JSON.parse(JSON.stringify(this.jobcard));
        createdJobCard.id = response.ID;
        createdJobCard.partnerID = response.PartnerID;
        createdJobCard.jobCardNo = response.JobCardNo;
        createdJobCard.statusID = response.StatusID;
        createdJobCard.preServiceChecklist = this.preServiceChecklist;

        console.log("Starting saving of tags if any are linked...");
        if (this.linkedTags && this.linkedTags.length > 0) {
          // Wait for every tag to save, then complete the save exactly once. Completing per-tag
          // would close the modal (and open the job card) once for each linked tag.
          forkJoin(
            this.linkedTags.map(tag =>
              this.serviceRequest.saveServiceTags(response.PartnerID, response.ID, { TagID: tag.id })
            )
          ).subscribe({
            next: () => { this.completeSave(response, createdJobCard, createAnother, openBooking); },
            error: () => { this.completeSave(response, createdJobCard, createAnother, openBooking); },
          });
        }
        else {
          this.completeSave(response, createdJobCard, createAnother, openBooking);
        }
      } else {
        this.busySchedulingService = false;
        console.error('Failed to schedule service:', response);
      }

    });

  }

  completeSave(response, createdJobCard, createAnother, openBooking = false) {
    if (this.groupBookings && this.canGroupBookings()) {
      var parentServiceID = this.jobCards[0].id;
      if (createdJobCard.id !== parentServiceID) {
        this.jobcardService.getLinkJobCard(this.helpersService.getPartnerId(), parentServiceID, createdJobCard.id).subscribe((result) => {
          createdJobCard.linked = true;
        });
      }
    }

    if (!createAnother) {
      this.activeModal.close({ jobcard: response, message: this.translate.instant("bikeshop.modal.shedule_service.service_scheduled", { jobCardNo: createdJobCard.jobCardNo }), openBooking: openBooking });
    } else {
      this.messageService.add({
        key: 'hubtiger-jobcard-toast',
        detail: this.translate.instant("bikeshop.modal.shedule_service.service_scheduled", { jobCardNo: createdJobCard.jobCardNo }),
        life: 5000
      });
      this.serviceRequest.getManageJobCardDetails(createdJobCard.id).subscribe((jobcard) => {
        createdJobCard = { ...jobcard };
        if (createdJobCard.quote == null) {
          //Handle cases where quote is null (might be failed jobcard bookings)
          createdJobCard.quote = {};
        }
        if (createdJobCard.quote?.couponResponse && createdJobCard.quote?.couponResponse.coupon) {
          createdJobCard.quote.couponDiscountType = createdJobCard.quote?.couponResponse.coupon.type;
          createdJobCard.quote.couponDiscount = createdJobCard.quote.couponResponse.coupon.percentValue || createdJobCard.quote.couponResponse.coupon.fixedValue;
        }
        this.jobCards.push(createdJobCard);
      });
      this.jobcard = JSON.parse(JSON.stringify({ ...this.originalJobcard, customer: createdJobCard.customer, fromCalendar: false, scheduleDate: moment(moment(createdJobCard.scheduleDate).format("YYYY-MM-DD")).toDate(), originalTechnician: createdJobCard.technician, technician: createdJobCard.technician }));
      this.getAvailableSlots(true, false);
      this.preServiceChecklist = JSON.parse(JSON.stringify(this.originalPreServiceChecklist));
      if (this.workshopJobcardAccordionComponent) {
        this.workshopJobcardAccordionComponent.reset();
        this.workshopJobcardAccordionComponent.onAddClick('item-details', null);
      }
    }

  }

  isJobCardValid(): boolean {
    return this.workshopJobcardCreateService.isJobCardValid(this.jobcard, this.preServiceChecklist);
  }

  selectJobCard(id: number) {
    this.showLinkedOverflow = false;
    if (id > 0 && this.jobCards?.length > 0) {
      var jobcard = this.jobCards.filter((jobCard) => { return jobCard.id === id; }).pop();
      if (jobcard) {
        if (this.jobcard && !this.jobcard.id) {
          this.draftJobcard = JSON.parse(JSON.stringify(this.jobcard));
          this.draftJobcard.preServiceChecklist = JSON.parse(JSON.stringify(this.preServiceChecklist));
        }
        this.jobcard = JSON.parse(JSON.stringify(jobcard));
        if (jobcard.preServiceChecklist && jobcard.preServiceChecklist.length > 0) {
          this.preServiceChecklist = JSON.parse(JSON.stringify(jobcard.preServiceChecklist));
        } else {
          this.preServiceChecklist = JSON.parse(JSON.stringify(this.originalPreServiceChecklist));
        }
      }
    } else if (id > 0 && this.linkedServices?.length > 0) {
      var jobcard = this.linkedServices.filter((service) => { return service.id === id; }).pop();
      if (jobcard && jobcard.id) {
        //this.jobCardID = jobcard.id;
        this.fetchJobCardDetails(jobcard.id);
        this.showLinkedServices = false;
      }
    } else {
      this.jobcard = JSON.parse(JSON.stringify(this.draftJobcard));
      this.preServiceChecklist = JSON.parse(JSON.stringify(this.draftJobcard.preServiceChecklist));
    }

  }

  getAvailableSlots(technicianSpecific = false, force = false) {
    this.workshopJobcardCreateService.getAvailableSlots(
      this.jobcard,
      this.jobcard.selectedServiceTypes.map(item => item.serviceTypeID),
      this.technicians,
      technicianSpecific,
      force
    ).subscribe(result => {
      this.jobcard = result.jobcard;
      this.technicians = result.technicians;
    });
  }

  getSystemUsers() {
    this.partnerService
      .getPartnerSystemUsers(this.helpersService.getPartnerId())
      .subscribe((users) => {
        this.systemUsers = users.map((x) => {
          return {
            value: x.ID,
            label: x.Name ? x.Name + ' ' + x.Surname : x.Email,
            name: x.Name ? x.Name + ' ' + x.Surname : x.Email,
            code: x.ID
          };
        });
        if (!this.jobcard.id &&
          this.systemUsers
            .map((x) => {
              return x.value;
            })
            .indexOf(this.helpersService.getProfileData().ID) > -1
        ) {
          this.jobcard.createdBy = this.helpersService.getProfileData().ID;
        }
        this.ctx.setSystemUsers(this.systemUsers);

        this.technicians = users.filter(user => {
          return user.UserRoles.some(role => role.RoleID === 1 || role.RoleID === 4)
        }).map((x) => {
          return {
            value: x.TechnicianID,
            label: x.Name + " " + x.Surname,
          };
        });
        this.ctx.setTechnicians(this.technicians);

        if (this.jobcard.scheduleDate == null && this.jobcard.technician == null) {
          this.getAvailableSlots();
        }
      });
  }

  canGroupBookings(): boolean {
    if (this.jobCards.length === 0) {
      return true;
    }
    const firstCustomerId = this.jobCards[0].customer?.ID;
    const currentCustomerId = this.jobcard.customer?.ID;
    return (this.jobCards.every(jobCard => jobCard.customer?.ID === firstCustomerId) && (currentCustomerId === firstCustomerId));
  }

  onChangeGroupBookings(event: any) {
    this.groupBookings = event.checked;

    if (this.groupBookings && this.canGroupBookings()) {

      const modalRef = this.modalService.open(WorkshopJobcardGroupJobsModalComponent, {
        backdrop: true,
        backdropClass: 'jobcard-modal-popup-backdrop',
        windowClass: 'jobcard-modal-popup-window',
        size: 'md'
      });

      modalRef.result.then(
        (result) => {
          if (result.groupJobs) {
            var parentServiceID = this.jobCards[0].id;
            this.jobCards.forEach(jobCard => {
              if (jobCard.id !== parentServiceID) {
                this.jobcardService.getLinkJobCard(this.helpersService.getPartnerId(), parentServiceID, jobCard.id).subscribe((result) => {
                  jobCard.linked = true;
                });
              } else {
                jobCard.linked = true;
              }
            });
          }
        },
        (onrejected) => {
          this.groupBookings = false;
        },
      );
    } else {
      this.groupBookings = false;
    }

  }

  showAllLinkedJobs() {
    this.showLinkedOverflow = false;
    this.showLinkedServices = true;
    this.jobcard.id = -1; //Set to a negative value to indicate no jobcard selected
  }

  // Set by the quote while the job card is being sent to the POS
  sendingToPOS: boolean = false;

  // Jobs linked to an external system must not be linked to other jobs
  get hasExternalLinkedService(): boolean {
    return (this.linkedServices || []).some(service => {
      const key = service.externalKey ?? service.ExternalKey;
      return key != null && String(key).trim() !== '';
    });
  }

  linkAnotherJob() {
    if (this.hasExternalLinkedService) return;
    this.showLinkedOverflow = false;
    const modalRef = this.modalService.open(WorkshopJobcardLinkServicesComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xxl'
    });

    modalRef.componentInstance.linkedServices = this.linkedServices;
    modalRef.componentInstance.linkableServices = this.linkableServices;
    modalRef.componentInstance.jobcardID = this.jobCardID;
    modalRef.componentInstance.linkedServicesUpdated.subscribe(() => {
      this.getLinkedjobCards();
    });

    modalRef.result.then(
      (result) => {
        this.getLinkedjobCards();
      },
      (onrejected) => {
        this.getLinkedjobCards();
      },
    );
  }

  getThirdParties() {
    this.thirdPartyService
      .getThirdParties(this.helpersService.getPartnerId())
      .subscribe((result) => {
        this.thirdParties = result.map((item) => {
          return {
            label: item.name,
            value: item.id,
            disabled: false,
          };
        });

        this.thirdParties.splice(0, 0, {
          label: this.translate.instant('bikeshop.message_templates.whatsapp.controls.whatsapp_header_options.none'),
          value: null,
          disabled: false,
        });
        this.ctx.setThirdParties(this.thirdParties);

      });
  }

  reloadJobcard(event) {
    this.fetchJobCardDetails(this.jobCardID);
  }

  setTags(event) {
    this.linkedTags = event;
  }
}

